export default __webpack_public_path__ + "static/media/dice-2.2ff4b385.svg";